import * as React from 'react';
import { PARAM_LANGUAGE } from 'PyzShopUi/scripts/product-review/constants';
import { ISetLanguagePayload, setLanguage } from 'PyzShopUi/scripts/product-review/actions/language';
import { ISelectOption } from 'PyzShopUi/scripts/shop-ui/interfaces';

function useLanguageSelect(itemsLanguageOptions: ISelectOption[], dispatch: React.Dispatch<any>): [ISelectOption[], (value: string) => void] {

    const onLanguageSelect = (value: string) => {
        const selectedApiQueryData: ISetLanguagePayload = {
            [PARAM_LANGUAGE]: value
        };

        dispatch(setLanguage(selectedApiQueryData));
    };

    return [itemsLanguageOptions, onLanguageSelect];
}

export default useLanguageSelect;
